var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKeyLeftArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 147,
    height: 147,
    viewBox: "0 0 147 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.429 52.0831C134.699 62.0161 136.066 81.6527 121.445 96.1256C121.902 95.7313 89.2883 132.716 72.2714 134.553C60.3341 135.842 51.903 125.021 50.7378 117.341C47.1621 93.7515 22.8084 91.0593 16.8823 79.3016C8.02153 61.7195 31.1605 44.6441 35.8774 41.4141L69.9315 17.882C78.6625 11.9074 89.0488 14.9193 96.1568 24.0268C101.425 36.8197 113.141 43.0793 125.429 52.0831Z",
    fill: "#DCCBBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.1222 37.47C42.1222 37.47 111.293 44.1292 123.137 52.1915C133.507 54.9509 137.112 75.2001 127.27 86.6413C127.27 86.6413 91.5225 123.76 78.6411 125.94C68.8603 127.596 60.7252 118.889 58.6191 113.189C51.5387 94.0216 33.3806 81.0225 23.215 75.43C16.0799 66.7051 16.7202 57.2245 42.1222 37.47Z",
    fill: "#ECDACD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.38 78.0494C133.62 71.5566 131.532 60.2823 123.824 51.6672C111.877 43.843 102.798 34.9381 96.4287 21.6527C88.7216 13.0387 75.7743 11.3148 67.5358 17.8068L39.6633 39.142C31.4238 45.6348 30.9924 57.8995 38.7004 66.5145C53.3247 76.1102 62.4925 86.5379 66.6306 97.731C74.3386 106.346 87.285 108.069 95.5245 101.576L125.38 78.0494Z",
    fill: "#FFEFE4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9273 62.1058L86.7417 46.8788L89.2529 44.5421L102.495 52.2722L99.461 55.0957L91.5991 50.2354L94.9268 59.3148L91.9273 62.1058Z",
    fill: "#666262"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M72.757 60.2168L76.2766 64.6013L73.434 67.2464C72.3702 68.2362 71.3348 68.73 70.3093 68.7809C69.2839 68.8318 68.0469 68.4293 66.5799 67.6265L67.3334 65.2634C68.2442 65.7528 68.9897 65.9984 69.5186 66.0121C70.0815 66.0302 70.5465 65.8505 70.9983 65.5024L69.3215 63.4135L72.757 60.2168Z",
    fill: "#666262"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyLeftArrow);
export default __webpack_public_path__ + "static/media/key-left-arrow.e1b8c79a9ba4e635ea4ab8287de862b8.svg";
export { ForwardRef as ReactComponent };